// Гейт аутентификации. На старте проверяет /api/v1/auth/me: вход не выполнен —
// показывает LoginScreen, иначе — приложение. Service worker регистрируется
// только после входа.

import type { JSX } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { AppShell } from '../../shell';
import { LoginScreen } from './LoginScreen';
import { auth } from '../../api';
import { registerServiceWorker } from '../push';
import { T } from '../../tokens';

type Status = 'checking' | 'login' | 'app';

export function AuthGate(): JSX.Element {
  const [status, setStatus] = useState<Status>('checking');

  useEffect(() => {
    let cancelled = false;
    auth
      .me()
      .then(() => {
        if (cancelled) return;
        setStatus('app');
        void registerServiceWorker();
      })
      .catch(() => {
        // 401 — вход не выполнен; любая иная ошибка — всё равно к экрану входа.
        if (!cancelled) setStatus('login');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') {
    return <div style={{ position: 'absolute', inset: 0, background: T.bg }} />;
  }
  if (status === 'login') {
    return (
      <LoginScreen
        onLoggedIn={() => {
          setStatus('app');
          void registerServiceWorker();
        }}
      />
    );
  }
  return <AppShell />;
}
